(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/preview-coverletter/page.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/preview-coverletter/page.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _React = React,
  useContext = _React.useContext,
  useRef = _React.useRef;
const OrderHomeContext = svs.ticketsOrderHome.context.OrderHomeContext;
const Envelope = svs.tur.Envelope;
const EnvelopeCross = svs.ticketOrderHome.pages.previewCoverLetter.components.EnvelopeCross;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils.constants.orderHomePreviewCoverLetter,
  TITLE = _svs$ticketsOrderHome.TITLE,
  EDIT_BTN_LABEL = _svs$ticketsOrderHome.EDIT_BTN_LABEL;
const CartBottomSheetPay = svs.ticketsOrderHome.orderHome.components.CartBottomSheetPay;
const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.routes.ORDER_HOME,
  MESSAGE = _svs$ticketsOrderHome2.MESSAGE,
  CONFIRMATION = _svs$ticketsOrderHome2.CONFIRMATION;
const trackOrderHomeOrderTransaction = svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeOrderTransaction;
const Button = svs.ui.ReactButton;
const PreviewCard = svs.ticketsOrderHome.orderHome.components.PreviewCard;
const orderTicketsGift = svs.ticketsOrderHome.services.orderTicketsGift;
const _svs$ticketsOrderHome3 = svs.ticketsOrderHome.utils,
  appendTicketThemeToOrderItems = _svs$ticketsOrderHome3.appendTicketThemeToOrderItems,
  getHasAfterPayParam = _svs$ticketsOrderHome3.getHasAfterPayParam;
const PreviewCoverletter = _ref => {
  let history = _ref.history;
  const _useContext = useContext(OrderHomeContext),
    state = _useContext.state,
    setOrder = _useContext.setOrder;
  const tickets = state.cart.tickets || [];
  const shouldDisplayEnvelope = tickets.length > 0;
  const ticketImages = tickets.map(_ref2 => {
    let image = _ref2.image;
    return image;
  }).sort((a, b) => b.width - b.height - (a.width - a.height)); 
  const afterPayRef = useRef(getHasAfterPayParam());
  const onEdit = () => {
    history.push(MESSAGE);
  };
  const handlePay = () => {
    const tickets = state.cart.tickets,
      personalGreeting = state.personalGreeting,
      message = state.greetingMessage,
      _state$receiver = state.receiver,
      details = _state$receiver.details,
      other = _state$receiver.other;
    orderTicketsGift({
      requestParams: {
        afterPay: afterPayRef.current,
        tickets,
        personalGreeting: "".concat(personalGreeting, "!"),
        message,
        addressReferenceId: details.id
      },
      onCancel: () => ({}),
      onDone: _ref3 => {
        let response = _ref3.response;
        const orderItems = (response === null || response === void 0 ? void 0 : response.orderItems) || [];
        const referenceId = response === null || response === void 0 ? void 0 : response.referenceId;
        const giftAddress = response === null || response === void 0 ? void 0 : response.giftAddress;
        if (orderItems.length) {
          const trackingItems = appendTicketThemeToOrderItems(orderItems).map(item => _objectSpread(_objectSpread({}, item), {}, {
            ticketOrder: other ? 'send_to_other' : 'send_to_me'
          }));
          trackOrderHomeOrderTransaction(referenceId, trackingItems, svs.ticketsOrderHome.utils.constants.SHIPPING_COST);
          const order = {
            orderItems,
            referenceId,
            giftAddress,
            isGift: true
          };
          setOrder(order);
          history.push(CONFIRMATION.replace(':referenceId', referenceId));
        }
      }
    });
  };
  React.useEffect(() => {
    if (afterPayRef.current) {
      handlePay();
    }
  }, []);
  return React.createElement("div", {
    className: "order-home-preview-cover-letter-page u-flex u-flex-column w100 u-flex-align-items-center padding-h-2 padding-bottom-1"
  }, React.createElement("div", {
    className: "order-home-preview-cover-letter-body w100 u-position-relative f-body"
  }, React.createElement("h2", {
    className: "h2 u-text-center padding-top-3"
  }, TITLE), React.createElement("div", {
    className: "preview-card-envelope-container"
  }, React.createElement(PreviewCard, null), React.createElement("div", {
    className: "order-home-preview-cover-letter-small-envelope u-position-absolute"
  }, shouldDisplayEnvelope && React.createElement(Envelope, {
    bodyColor: "#FFFBCC",
    branding: "triss",
    className: "preview-cover-letter-envelope",
    images: ticketImages,
    split: true
  }, React.createElement(EnvelopeCross, null)))), React.createElement(Button, {
    block: true,
    className: "margin-v-2",
    onClick: onEdit,
    transparent: true
  }, EDIT_BTN_LABEL)), React.createElement(CartBottomSheetPay, {
    onPay: handlePay
  }));
};
setGlobal('svs.ticketsOrderHome.pages.PreviewCoverletter', PreviewCoverletter);

 })(window);